/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerComponents } from "../../../../../shared/context/PlayerComponentsContext";
import { usePlayerConfig } from "../../../../../shared/context/PlayerConfigContext";
import { usePlayerTranslation } from "../../../../../shared/context/PlayerTranslationContext";
import MaximizeIcon from "../../../../../shared/icons/player/Fullscreen.svg";
import MinimizeIcon from "../../../../../shared/icons/player/Minimize.svg";
import { usePlayerSettings, usePlayerTimer } from "../../../../BasePlayer";
import { usePlayerFullScreen } from "../../../../Controller";
import { useOverlayState } from "../../../../Overlay";

export const ToggleFullScreenButton = () => {
  const { toggle, isFullScreen } = usePlayerFullScreen();
  const { isRTL } = usePlayerConfig();

  const {
    timer: { isLive, isInfinityStream },
  } = usePlayerTimer();

  const isLastButton = !(isLive || isInfinityStream) && !isRTL;

  const { settings } = useOverlayState();

  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();
  const label = t(
    isFullScreen
      ? "PLAYER_TOOLTIP_LEAVE_FULLSCREEN"
      : "PLAYER_TOOLTIP_ENTER_FULLSCREEN",
  );

  return (
    <Button
      variant="secondary"
      onClick={toggle}
      tooltip={!settings ? label : ""}
      tooltipAlign={isLastButton ? "right" : "center"}
      tooltipOffset={tooltipOffset}
      aria-label={label}
      iconOnly
    >
      {isFullScreen ? (
        <MinimizeIcon aria-hidden="true" focusable="false" />
      ) : (
        <MaximizeIcon aria-hidden="true" focusable="false" />
      )}
    </Button>
  );
};
